@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.core.`init`.InitKobwebContext
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Suppress
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import com.klantenstop.web.pages.HomePage as _com_klantenstop_web_pages_HomePage
import com.klantenstop.web.pages.about.AboutPage as _com_klantenstop_web_pages_about_AboutPage
import com.klantenstop.web.pages.admin.AdminHomePage as _com_klantenstop_web_pages_admin_AdminHomePage
import com.klantenstop.web.pages.admin.categories.CategoriesPage as _com_klantenstop_web_pages_admin_categories_CategoriesPage
import com.klantenstop.web.pages.admin.categories.manage.ManageCategoryPage as _com_klantenstop_web_pages_admin_categories_manage_ManageCategoryPage
import com.klantenstop.web.pages.admin.companies.CompaniesPage as _com_klantenstop_web_pages_admin_companies_CompaniesPage
import com.klantenstop.web.pages.admin.companies.manage.ManageCompanyPage as _com_klantenstop_web_pages_admin_companies_manage_ManageCompanyPage
import com.klantenstop.web.pages.admin.curatedcities.CuratedCitiesPage as _com_klantenstop_web_pages_admin_curatedcities_CuratedCitiesPage
import com.klantenstop.web.pages.admin.curatedcities.manage.ManageCuratedCityPage as _com_klantenstop_web_pages_admin_curatedcities_manage_ManageCuratedCityPage
import com.klantenstop.web.pages.admin.moderation.ModerationQueuePage as _com_klantenstop_web_pages_admin_moderation_ModerationQueuePage
import com.klantenstop.web.pages.admin.settings.SettingsPage as _com_klantenstop_web_pages_admin_settings_SettingsPage
import com.klantenstop.web.pages.authentication.companyRegistration.RegisterPage as _com_klantenstop_web_pages_authentication_companyRegistration_RegisterPage
import com.klantenstop.web.pages.authentication.forgotPassword.ForgotPasswordPage as _com_klantenstop_web_pages_authentication_forgotPassword_ForgotPasswordPage
import com.klantenstop.web.pages.authentication.login.LoginPage as _com_klantenstop_web_pages_authentication_login_LoginPage
import com.klantenstop.web.pages.authentication.registration.RegisterPage as _com_klantenstop_web_pages_authentication_registration_RegisterPage
import com.klantenstop.web.pages.authentication.resetPassword.ResetPasswordPage as _com_klantenstop_web_pages_authentication_resetPassword_ResetPasswordPage
import com.klantenstop.web.pages.authentication.verifyEmail.VerifyEmailPage as _com_klantenstop_web_pages_authentication_verifyEmail_VerifyEmailPage
import com.klantenstop.web.pages.categories.AllCategoriesPage as _com_klantenstop_web_pages_categories_AllCategoriesPage
import com.klantenstop.web.pages.company.CompanyPage as _com_klantenstop_web_pages_company_CompanyPage
import com.klantenstop.web.pages.contact.ContactPage as _com_klantenstop_web_pages_contact_ContactPage
import com.klantenstop.web.pages.healthcare.PatientStopWaitlistPage as _com_klantenstop_web_pages_healthcare_PatientStopWaitlistPage
import com.klantenstop.web.pages.legal.PrivacyPolicyPage as _com_klantenstop_web_pages_legal_PrivacyPolicyPage
import com.klantenstop.web.pages.legal.TermsAndConditionsPage as _com_klantenstop_web_pages_legal_TermsAndConditionsPage
import com.klantenstop.web.pages.manageCompany.ManageCompanyPage as _com_klantenstop_web_pages_manageCompany_ManageCompanyPage
import com.klantenstop.web.pages.profile.ProfilePage as _com_klantenstop_web_pages_profile_ProfilePage
import com.klantenstop.web.pages.search.SearchPage as _com_klantenstop_web_pages_search_SearchPage
import com.klantenstop.web.pages.search.SearchPageWithFilters as _com_klantenstop_web_pages_search_SearchPageWithFilters
import com.klantenstop.web.pages.settings.SettingsPage as _com_klantenstop_web_pages_settings_SettingsPage

public fun main() {
    AppGlobals.initialize(mapOf("title" to "KlantenStop", "BASE_URL" to "https://dev.klantenstop.be", "ENVIRONMENT" to "development", "ADSENSE_CLIENT_ID" to "", "ADSENSE_HOME_SLOT_ID" to "", "ADSENSE_SEARCH_SLOT_ID" to "", "POSTHOG_API_KEY" to "", "POSTHOG_HOST" to "https://eu.i.posthog.com"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register(
            "/",
        ) { pageCtx -> 
            _com_klantenstop_web_pages_HomePage()
        }
        ctx.router.register(
            "/admin",
        ) { pageCtx -> 
            _com_klantenstop_web_pages_admin_AdminHomePage()
        }
        ctx.router.register(
            "/admin/bedrijven",
        ) { pageCtx -> 
            _com_klantenstop_web_pages_admin_companies_CompaniesPage()
        }
        ctx.router.register(
            "/admin/bedrijven/beheren",
        ) { pageCtx -> 
            _com_klantenstop_web_pages_admin_companies_manage_ManageCompanyPage()
        }
        ctx.router.register(
            "/admin/categorieen",
        ) { pageCtx -> 
            _com_klantenstop_web_pages_admin_categories_CategoriesPage()
        }
        ctx.router.register(
            "/admin/categorieen/beheren",
        ) { pageCtx -> 
            _com_klantenstop_web_pages_admin_categories_manage_ManageCategoryPage()
        }
        ctx.router.register(
            "/admin/instellingen",
        ) { pageCtx -> 
            _com_klantenstop_web_pages_admin_settings_SettingsPage()
        }
        ctx.router.register(
            "/admin/moderatie",
        ) { pageCtx -> 
            _com_klantenstop_web_pages_admin_moderation_ModerationQueuePage()
        }
        ctx.router.register(
            "/admin/steden",
        ) { pageCtx -> 
            _com_klantenstop_web_pages_admin_curatedcities_CuratedCitiesPage()
        }
        ctx.router.register(
            "/admin/steden/beheren",
        ) { pageCtx -> 
            _com_klantenstop_web_pages_admin_curatedcities_manage_ManageCuratedCityPage()
        }
        ctx.router.register(
            "/algemene-voorwaarden",
        ) { pageCtx -> 
            _com_klantenstop_web_pages_legal_TermsAndConditionsPage()
        }
        ctx.router.register(
            "/bedrijf-registreren",
        ) { pageCtx -> 
            _com_klantenstop_web_pages_authentication_companyRegistration_RegisterPage()
        }
        ctx.router.register(
            "/bedrijf/{companyIdentifier}",
        ) { pageCtx -> 
            _com_klantenstop_web_pages_company_CompanyPage(pageCtx)
        }
        ctx.router.register(
            "/bedrijven/beheren/{companyIdentifier?}",
        ) { pageCtx -> 
            _com_klantenstop_web_pages_manageCompany_ManageCompanyPage(pageCtx)
        }
        ctx.router.register(
            "/categorieen",
        ) { pageCtx -> 
            _com_klantenstop_web_pages_categories_AllCategoriesPage()
        }
        ctx.router.register(
            "/contact",
        ) { pageCtx -> 
            _com_klantenstop_web_pages_contact_ContactPage()
        }
        ctx.router.register(
            "/inloggen",
        ) { pageCtx -> 
            _com_klantenstop_web_pages_authentication_login_LoginPage()
        }
        ctx.router.register(
            "/instellingen",
        ) { pageCtx -> 
            _com_klantenstop_web_pages_settings_SettingsPage()
        }
        ctx.router.register(
            "/over-ons",
        ) { pageCtx -> 
            _com_klantenstop_web_pages_about_AboutPage()
        }
        ctx.router.register(
            "/patientenstop-wachtlijst",
        ) { pageCtx -> 
            _com_klantenstop_web_pages_healthcare_PatientStopWaitlistPage()
        }
        ctx.router.register(
            "/privacybeleid",
        ) { pageCtx -> 
            _com_klantenstop_web_pages_legal_PrivacyPolicyPage()
        }
        ctx.router.register(
            "/profiel",
        ) { pageCtx -> 
            _com_klantenstop_web_pages_profile_ProfilePage()
        }
        ctx.router.register(
            "/registreren",
        ) { pageCtx -> 
            _com_klantenstop_web_pages_authentication_registration_RegisterPage()
        }
        ctx.router.register(
            "/verifieren",
        ) { pageCtx -> 
            _com_klantenstop_web_pages_authentication_verifyEmail_VerifyEmailPage()
        }
        ctx.router.register(
            "/wachtwoord-resetten",
        ) { pageCtx -> 
            _com_klantenstop_web_pages_authentication_resetPassword_ResetPasswordPage()
        }
        ctx.router.register(
            "/wachtwoord-vergeten",
        ) { pageCtx -> 
            _com_klantenstop_web_pages_authentication_forgotPassword_ForgotPasswordPage()
        }
        ctx.router.register(
            "/zoeken",
        ) { pageCtx -> 
            _com_klantenstop_web_pages_search_SearchPage()
        }
        ctx.router.register(
            "/zoeken/{categorie}/{stad?}",
        ) { pageCtx -> 
            _com_klantenstop_web_pages_search_SearchPageWithFilters()
        }

        com.klantenstop.web.pages.initErrorPage(ctx)
    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("visually-hidden", com.klantenstop.web.components.VisuallyHiddenStyle)
        ctx.theme.registerStyle("custom-select", com.klantenstop.web.components.CustomSelectStyle)
        ctx.theme.registerStyle("custom-select-trigger", com.klantenstop.web.components.CustomSelectTriggerStyle)
        ctx.theme.registerStyle("custom-select-menu", com.klantenstop.web.components.CustomSelectMenuStyle)
        ctx.theme.registerStyle("custom-select-option", com.klantenstop.web.components.CustomSelectOptionStyle)
        ctx.theme.registerStyle("typography_display-large", com.klantenstop.web.styles.Typography.DisplayLarge)
        ctx.theme.registerStyle("typography_display-medium", com.klantenstop.web.styles.Typography.DisplayMedium)
        ctx.theme.registerStyle("typography_display-small", com.klantenstop.web.styles.Typography.DisplaySmall)
        ctx.theme.registerStyle("typography_headline-large", com.klantenstop.web.styles.Typography.HeadlineLarge)
        ctx.theme.registerStyle("typography_headline-medium", com.klantenstop.web.styles.Typography.HeadlineMedium)
        ctx.theme.registerStyle("typography_headline-small", com.klantenstop.web.styles.Typography.HeadlineSmall)
        ctx.theme.registerStyle("typography_title-large", com.klantenstop.web.styles.Typography.TitleLarge)
        ctx.theme.registerStyle("typography_title-medium", com.klantenstop.web.styles.Typography.TitleMedium)
        ctx.theme.registerStyle("typography_title-small", com.klantenstop.web.styles.Typography.TitleSmall)
        ctx.theme.registerStyle("typography_body-large", com.klantenstop.web.styles.Typography.BodyLarge)
        ctx.theme.registerStyle("typography_body-medium", com.klantenstop.web.styles.Typography.BodyMedium)
        ctx.theme.registerStyle("typography_body-small", com.klantenstop.web.styles.Typography.BodySmall)
        ctx.theme.registerStyle("typography_label-large", com.klantenstop.web.styles.Typography.LabelLarge)
        ctx.theme.registerStyle("typography_label-medium", com.klantenstop.web.styles.Typography.LabelMedium)
        ctx.theme.registerStyle("typography_label-small", com.klantenstop.web.styles.Typography.LabelSmall)
        ctx.theme.registerStyle("valid-feedback", com.materialkobweb.styles.validFeedbackStyle)
        ctx.theme.registerStyle("invalid-feedback", com.materialkobweb.styles.invalidFeedbackStyle)
        ctx.theme.registerStyle("button-size-xl", com.materialkobweb.extensions.ButtonSizeXL)
        ctx.theme.registerStyle("button-link", com.materialkobweb.components.widgets.ButtonLinkStyle)
        ctx.theme.registerStyle("multi-select", com.materialkobweb.components.widgets.MultiSelectStyle)
        ctx.theme.registerStyle("multi-select-defaults_size", com.materialkobweb.components.widgets.MultiSelectDefaults.Size)
        ctx.theme.registerStyle("multi-select-size_xs", com.materialkobweb.components.widgets.MultiSelectSize.Companion.XS)
        ctx.theme.registerStyle("multi-select-size_sm", com.materialkobweb.components.widgets.MultiSelectSize.Companion.SM)
        ctx.theme.registerStyle("multi-select-size_md", com.materialkobweb.components.widgets.MultiSelectSize.Companion.MD)
        ctx.theme.registerStyle("multi-select-size_lg", com.materialkobweb.components.widgets.MultiSelectSize.Companion.LG)
        ctx.theme.registerStyle("select", com.materialkobweb.components.widgets.SelectStyle)
        ctx.theme.registerStyle("valid-select", com.materialkobweb.components.widgets.validSelectStyle)
        ctx.theme.registerStyle("invalid-select", com.materialkobweb.components.widgets.invalidSelectStyle)
        ctx.theme.registerStyle("select-form-floating", com.materialkobweb.components.widgets.SelectFormFloating)
        ctx.theme.registerStyle("select-defaults_size", com.materialkobweb.components.widgets.SelectDefaults.Size)
        ctx.theme.registerStyle("select-size_xs", com.materialkobweb.components.widgets.SelectSize.Companion.XS)
        ctx.theme.registerStyle("select-size_sm", com.materialkobweb.components.widgets.SelectSize.Companion.SM)
        ctx.theme.registerStyle("select-size_md", com.materialkobweb.components.widgets.SelectSize.Companion.MD)
        ctx.theme.registerStyle("select-size_lg", com.materialkobweb.components.widgets.SelectSize.Companion.LG)
        ctx.theme.registerStyle("checked-input", com.materialkobweb.components.widgets.CheckedInputStyle)
        ctx.theme.registerStyle("ds-external-link", com.materialkobweb.components.widgets.DsExternalLinkStyle)
        ctx.theme.registerStyle("ds-card", com.materialkobweb.components.widgets.DsCardStyle)
        ctx.theme.registerStyle("silk-text-area", com.materialkobweb.components.widgets.TextAreaStyle)
        ctx.theme.registerStyle("navigation-item", com.materialkobweb.components.sections.NavigationItemStyle)
        ctx.theme.registerVariant("-downward", com.klantenstop.web.components.DownwardCustomSelectMenuVariant)
        ctx.theme.registerVariant("-upward", com.klantenstop.web.components.UpwardCustomSelectMenuVariant)
        ctx.theme.registerVariant("-selected", com.klantenstop.web.components.SelectedCustomSelectOptionVariant)
        ctx.theme.registerVariant("-error-text-button-style", com.klantenstop.web.styles.ErrorTextButtonStyle)
        ctx.theme.registerVariant("-primary-text-button-style", com.klantenstop.web.styles.PrimaryTextButtonStyle)
        ctx.theme.registerVariant("-extended-undecorated", com.klantenstop.web.components.ExtendedUndecoratedLinkVariant)
        ctx.theme.registerVariant("-elevated", com.materialkobweb.components.widgets.ElevatedButtonLinkVariant)
        ctx.theme.registerVariant("-filled", com.materialkobweb.components.widgets.FilledButtonLinkVariant)
        ctx.theme.registerVariant("-outlined", com.materialkobweb.components.widgets.OutlinedButtonLinkVariant)
        ctx.theme.registerVariant("-filled-tonal", com.materialkobweb.components.widgets.FilledTonalButtonLinkVariant)
        ctx.theme.registerVariant("-text", com.materialkobweb.components.widgets.TextButtonLinkVariant)
        ctx.theme.registerVariant("-primary-text-button-link-style", com.materialkobweb.components.widgets.PrimaryTextButtonLinkStyle)
        ctx.theme.registerVariant("-outlined-multi-select-style", com.materialkobweb.components.widgets.OutlinedMultiSelectStyle)
        ctx.theme.registerVariant("-", com.materialkobweb.components.widgets.MultiSelectDefaults.Variant)
        ctx.theme.registerVariant("-outlined-select-style", com.materialkobweb.components.widgets.OutlinedSelectStyle)
        ctx.theme.registerVariant("-unstyled-select-style", com.materialkobweb.components.widgets.UnstyledSelectStyle)
        ctx.theme.registerVariant("-", com.materialkobweb.components.widgets.SelectDefaults.Variant)
        ctx.theme.registerVariant("-elevated-button-style", com.materialkobweb.components.widgets.ElevatedButtonStyle)
        ctx.theme.registerVariant("-filled-button-style", com.materialkobweb.components.widgets.FilledButtonStyle)
        ctx.theme.registerVariant("-outlined-button-style", com.materialkobweb.components.widgets.OutlinedButtonStyle)
        ctx.theme.registerVariant("-filled-tonal-button-style", com.materialkobweb.components.widgets.FilledTonalButtonStyle)
        ctx.theme.registerVariant("-text-button-style", com.materialkobweb.components.widgets.TextButtonStyle)
        ctx.theme.registerVariant("-elevated-icon-button-style", com.materialkobweb.components.widgets.ElevatedIconButtonStyle)
        ctx.theme.registerVariant("-filled-icon-button-style", com.materialkobweb.components.widgets.FilledIconButtonStyle)
        ctx.theme.registerVariant("-outlined-icon-button-style", com.materialkobweb.components.widgets.OutlinedIconButtonStyle)
        ctx.theme.registerVariant("-filled-tonal-icon-button-style", com.materialkobweb.components.widgets.FilledTonalIconButtonStyle)
        ctx.theme.registerVariant("-icon-button-style", com.materialkobweb.components.widgets.IconButtonStyle)
        ctx.theme.registerVariant("-ds-card-clickable-style", com.materialkobweb.components.widgets.DsCardClickableStyle)
        ctx.theme.registerVariant("-outlined", com.materialkobweb.components.widgets.OutlinedTextAreaVariant)
        ctx.theme.registerKeyframes("rotation-key-frames", com.materialkobweb.components.widgets.rotationKeyFrames)
        ctx.theme.registerKeyframes("slide-in", com.materialkobweb.components.toast.SlideIn)
        ctx.theme.registerKeyframes("slide-out", com.materialkobweb.components.toast.SlideOut)
        com.klantenstop.web.initColorMode(ctx)
        com.materialkobweb.updateTheme(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        com.klantenstop.web.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
